/****************************************************
 * Module Name:  employeeMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Box } from "@mui/material";
import EmployeeMasterComponent from "../common/employeeMasterComponent";

export class EmployeeMaster extends Component {
  render() {
    return (
      <Box>
        <EmployeeMasterComponent editButton={true} />
      </Box>
    );
  }
}

export default EmployeeMaster;
